import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import HttpClient from '@@/package/network/HttpClient';
import {type AxiosResponse} from 'axios';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import type {SurveyResponseModel} from "~~/package/mapper/survey/model/SurveyResponseModel";
import type SurveyCompletionResponse from "~~/package/apis/survey/response/SurveyCompletionResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class SurveyApi {

    protected http: HttpClient;

    constructor(context: ApplicationContextInterface) {
        this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
    }

    // 인증 필수: HttpOnly 쿠키는 withCredentials 로 자동 전송, 레거시 세션은 includeToken=true 로 Bearer 부착
    public submitSurveyResponse(request: SurveyResponseModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<boolean>>, SurveyResponseModel>('/v2/surveys/responses', request, true);
    }

    public getSurveyCompletions(): Promise<AxiosResponse<CustomResponse<SurveyCompletionResponse[]>>> {
        return this.http.get<AxiosResponse<CustomResponse<SurveyCompletionResponse[]>>>('/v2/surveys/completions', undefined, true);
    }
}
